export const AUTH_LOGIN_FAILED_CREDENTIALS = {
  code: 4000,
  message: 'Sorry, we could not log you in with those credentials',
}

export const AUTH_SIGNUP_FAILED = {
  code: 4001,
  message: 'Sorry, we cannot create an account with those credentials',
}

export const FILE_TOO_LARGE = {
  message: 'The file you selected is too large, please choose a smaller one',
}
